import * as React from "react";
import { Table } from "semantic-ui-react";

interface Props {
    customerName: string;
    orgStructure: string[];
}

const CustomerDetails: React.FunctionComponent<Props> = (props) => {
    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>
                        Customer Details
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Table.Row>
                    <Table.Cell>
                        <strong>{props.customerName}</strong>
                    </Table.Cell>
                </Table.Row>
                {props.orgStructure.filter(o => o?.length > 0).map(orgStructure => (
                    <Table.Row key={orgStructure}>
                        <Table.Cell>
                            {orgStructure}
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};

export { CustomerDetails };
